export default {"src":"/_next/static/media/icon_info_filled.8251dac3.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};